﻿$.fn.dxCtrlReinitPwdSupport = function custom_dxCtrlReinitPwdSupport(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlreinitpwdsupport dx-ctrl");
        this.createInstance(new cdxCtrlReinitPwdSupport(this, option));
    }
    return this;
}

window.cdxCtrlReinitPwdSupport = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    function mConstruit() {
        container.empty();

        container.css({
            "display": "flex",
            //"align-items": "center",
            "padding-top": "100px",
            "justify-content": "center",
            "height": "100%",
            "width": "100%"
        })
        $DivContainer = $("<div style='width:300px;'/>").appendTo(container)

        var img = parametre.img
        var nom = parametre.nom

        var $DivImg = $("<div style='text-align:center;'/>").appendTo($DivContainer)
        var $Img = $("<img src='" + img + "' style='width:70px'/>").appendTo($DivImg)

        var $Div = $("<div class='dx-theme-accent-as-background-color'/>").appendTo("body");
        backgroundcolorAccent = $Div.css("background-color");
        $Div.remove();
        var $DivGlitchWrapper = $("<div class='glitch-wrapper'/>").appendTo($DivImg)
        $("<div class='glitch' data-glitch='glitch'>Support " + nom + "</div>").appendTo($DivGlitchWrapper)


        var $DivConnexion = $("<div/>").appendTo($DivContainer);
        if (typeof option.sansMotDePasse != 'undefined' && option.sansMotDePasse) {
            $("<div style='text-align:center;padding-top:20px;'>C'est la première fois que vous vous connectez.<br/>Veuillez cliquer pour demander un lien pour créer votre mot de passe.</div>").appendTo($DivConnexion)
        } else {
            $("<div style='text-align:center;padding-top:20px;'>Demander un lien pour réinitialiser votre mot de passe</div>").appendTo($DivConnexion)
        }


        $("<br/>").appendTo($DivConnexion)
        $("<br/>").appendTo($DivConnexion)
        dxAdrEmail = $("<div/>").appendTo($DivConnexion).dxTextBox({
            labelMode: 'floating',
            label: "Adresse email",
            value: ((typeof option.adresseEmail != 'undefined') ? option.adresseEmail : ""),
            placeholder: "Adresse email de connexion..." + String.fromCharCode(160),
            width: "100%",
            mode: "email",
            onKeyUp: function (e) {
                if (e.event.keyCode == 13) {
                    if (!dxPwd.option("value") || dxPwd.option("value").length == 0) { dxPwd.focus(); }
                }
            }
        }).dxTextBox("instance")

        var $DivBt = $("<div style='text-align:right;padding-top:30px'/>").appendTo($DivConnexion)
        var dxBtConnect = $("<div/>").appendTo($DivBt).dxButton({
            text: "Recevoir un lien",
            focus: true,
            onClick: function (e) {
                if (dxAdrEmail.option("value") == null || dxAdrEmail.option("value").length == 0) {
                    mNotify("Veuillez saisir une adresse email", "warning", 6000)
                    dxAdrEmail.focus()
                    return
                }
                var dataToBeSent = {
                    command: 'demandereinitpwdwithemail',
                    adresse_email: dxAdrEmail.option("value"),
                    nom_table: "utilisateur",
                    nom_table2: "compte_client"
                }
                jaugeDemarrage.mShow()
                var url = '/ext/handlerexterne.ashx?timestamp=' + new Date().getTime();
                $.post(url, dataToBeSent, function (data) {
                    if (data.root.resultat == "ok") {
                        if (data.root.emailenvoye == "1") {
                            mNotify("Un email vous permettant de réinitialiser votre mot de passe vous a été envoyé. Veuillez consulter vos emails et suivre les instructions.<br/>(Si vous ne recevez pas notre email, vérifiez que celui-ci ne se trouve pas dans vos courriers indésirables)", "success", 25000)
                            option.onClose()
                        } else {
                            mNotify("Impossible de vous envoyer un email. Veuiller vérifier l'adresse que vous avez saisie.", "error", 15000)
                        }
                    }
                    else {
                        if (typeof data.root.message != 'undefined') { mNotify(data.root.message, "error", 5000) }
                        else { mNotify("Impossible d'envoyer l'email.", "error", 15000); }
                    }
                }, 'json')
                    .fail(function (data) {
                        console.log(data.responseText)
                        mNotify("Impossible d'envoyer l'email.", "error", 15000);
                    })
                    .always(function (data) {
                        jaugeDemarrage.mHide();
                    });
            }
        }).dxButton("instance");

        var $DivRetour = $("<div style='text-align:right;padding-top:20px;'/>").appendTo($DivConnexion)
        var $A = $("<a href='javascript:void(0)'>Retour à la page de login</a>").appendTo($DivRetour)
        $A.on("click", function () {
            option.onClose()
        })
    }

    mConstruit();

}